import type { BuyerReservation } from './api';

/// What the buyer reads for each state of their reservation.
export const buyerReservationStatusLabels: Record<BuyerReservation['status'], string> = {
  ACTIVE: 'Activa',
  EXPIRED: 'Vencida',
  CANCELLED: 'Cancelada',
  COMPLETED: 'Concretada',
};

/// The conditions a buyer accepts by reserving (P-A1, P-B1, P-I5). PhoneTec validates the words
/// in X-2; until then, this is the team's draft.
export const reservationConditions =
  'La reserva no tiene costo y dura 3 días. Se paga y se retira en el local. PhoneTec te contacta para coordinar.';

export function describeReservedDevice(device: BuyerReservation['device']): string {
  return [
    device.brand,
    device.model,
    device.storageGb ? `${device.storageGb}GB` : null,
    device.color,
  ]
    .filter(Boolean)
    .join(' ');
}

const PENDING_KEY = 'phonetec.pendingReservationDevice';

/// The device a buyer wanted to reserve before verifying the mail, so the verification page can
/// take them back to it. Lives in this browser only; losing it costs one trip to the catalog.
export function rememberPendingReservation(deviceId: string): void {
  try {
    window.localStorage.setItem(PENDING_KEY, deviceId);
  } catch {
    // Private mode or blocked storage: the buyer finds the device again in the catalog.
  }
}

export function takePendingReservation(): string | null {
  try {
    const deviceId = window.localStorage.getItem(PENDING_KEY);
    window.localStorage.removeItem(PENDING_KEY);
    return deviceId;
  } catch {
    return null;
  }
}
